import { jsx as e, jsxs as T } from "react/jsx-runtime";
import { forwardRef as w, useRef as A } from "react";
import { c as C } from "../../index-Cu0xwYjD.js";
import { PopoverType as I } from "./Popover.types.js";
import { FloatingUIAlign as N, GlobalCSSClass as j } from "../../utils/enums.js";
import { idsLogger as F, propagateTestid as r } from "../../utils/helpers.js";
import { s as R } from "../../Popover.module-B-m2_dp_.js";
import { PopoverProvider as S } from "./PopoverProvider.js";
import { PopoverActivator as b } from "./components/PopoverActivator.js";
import { PopoverContent as k } from "./components/PopoverContent.js";
import { composePopoverWidth as E } from "./helpers/composePopoverWidth.js";
const G = ({
  activator: s,
  align: a = "auto",
  children: m,
  className: p,
  container: d,
  contentClassName: l,
  defaultShow: n,
  disabledAutoToggle: f,
  displayMode: c = "overlay",
  onActivated: v,
  onDeactivated: h,
  onNavigate: g,
  type: P,
  show: y,
  width: t,
  ...o
}, u) => {
  const x = A(null);
  return t !== void 0 && F(
    "IressPopover: The width prop is deprecated. Please use the --iress-width and --iress-max-width design token instead."
  ), /* @__PURE__ */ e(
    S,
    {
      align: a,
      defaultShow: n,
      disabledAutoToggle: f,
      onActivated: v,
      onDeactivated: h,
      onNavigate: g,
      ref: u,
      show: y,
      type: P,
      children: /* @__PURE__ */ T(
        "div",
        {
          ...o,
          className: C(
            p,
            j.FormElement,
            R.popover
          ),
          ref: x,
          children: [
            /* @__PURE__ */ e(
              b,
              {
                "data-testid": r(o["data-testid"], "activator"),
                children: s
              }
            ),
            /* @__PURE__ */ e(
              k,
              {
                className: l,
                container: d,
                "data-testid": r(o["data-testid"], "content"),
                displayMode: c,
                style: { ...E(t), ...o.style },
                children: m
              }
            )
          ]
        }
      )
    }
  );
}, i = w(G);
i.Align = N;
i.Type = I;
export {
  i as IressPopover
};
